
import {combineLatest as observableCombineLatest, Subscription} from 'rxjs';
import {Component, OnDestroy, OnInit, ViewChild, AfterViewChecked} from '@angular/core';
import {Router} from '@angular/router';
import {NgForm} from '@angular/forms';
import {Register} from '../register.service';
import {JhiEventManager} from 'ng-jhipster';
import {EditableAccount, ScrollToService, CaptchaService, CreateAccountErrorType, AccountType} from '../../../shared/index';
import {CaptchaComponent} from '../../../shared/components/captcha/captcha.component';
import {ErrorService} from '../../../shared/services/error.service';
import {ParametersService} from '../../../shared/services/parameters.service';
import {Country} from '../../../shared/model/parameters.model';
import {AccountData} from '../../../shared/components/identite-personne/data/account.data';

@Component({
    selector: 'jhi-personne-morale',
    templateUrl: './personne-morale.component.html',
    styleUrls: ['./personne-morale.component.scss']
})
export class PersonneMoraleComponent implements OnInit, OnDestroy, AfterViewChecked {

    newAccount: EditableAccount;
    isTechnicalError: boolean;
    enableScroll: boolean;
    isCreateAccountBtnClicked = false;

    @ViewChild('registerForm') registerForm: NgForm;

    @ViewChild(CaptchaComponent) captcha: CaptchaComponent;

    civilites: Array<string>;

    countries: Array<Country>;

    private subscription: Subscription;

    constructor(private registerService: Register,
        private eventManager: JhiEventManager,
        private router: Router,
        private scrollToService: ScrollToService,
        private captchaService: CaptchaService,
        private errorService: ErrorService,
        private parametersService: ParametersService,
        private accountData: AccountData
    ) {}

    ngOnInit() {
        this.subscription = observableCombineLatest( this.registerService.newAccountAsObservable(), this.parametersService.getParameters()
        ).subscribe(([newAccount, parameters]) => {
            this.countries = parameters.countries;
            this.civilites = parameters.civilities;
            this.newAccount = newAccount;
            this.newAccount.type = AccountType.MORALE;
            this.newAccount.address.pays = this.newAccount.address.pays || 'France';
        });
    }

    ngAfterViewChecked(): void {
        if (this.registerForm.submitted && !this.registerForm.valid && this.enableScroll) {
            this.scrollToService.scrollToFirstError();
            this.enableScroll = false;
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    register() {
        if (!this.registerForm.valid) {
            this.errorService.markAllControlsAsTouched(this.registerForm);
            this.captchaService.reloadCaptcha();
        } else {
            this.isTechnicalError = false;
            this.registerService.save(this.newAccount.toAccountDTO())
                .subscribe(
                    _ => this.registerSucceeded(),
                    error => this.processError(error)
                );
        }
        this.enableScroll = true;
    }

    registerSucceeded() {
        this.eventManager.broadcast({
            name: 'authenticationSuccess',
            content: 'Sending Authentication Success'
        });
        this.accountData.email = this.newAccount.credentials.email;
        this.router.navigate(['/inscription-reussie']);
    }

    private processError(error) {
        this.captchaService.reloadCaptcha();
        if (error.error.code === CreateAccountErrorType.EMAIL_ALREADY_IN_USE) {
            this.registerForm.controls['email'].setErrors({'invalid': true, 'emailexists': true});
        } else if (error.error.code === CreateAccountErrorType.INVALID_PASSWORD) {
            this.registerForm.controls['password'].setErrors({'invalid': true, 'invalidPassword': true });
            this.errorService.markAllControlsAsTouched(this.registerForm);
        } else {
            this.isTechnicalError = true;
        }
    }

    cancel() {
        this.registerService.cancel();
    }

    captchaChange(captcha: string) {
        this.newAccount.captcha = captcha;
    }

    clickCheck() {
        this.isCreateAccountBtnClicked = true;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/personne-morale/personne-morale.component.ts